import { useSyncExternalStore } from 'react';

// Phones: below antd's `screenMD`, the same breakpoint as the `@media (max-width: 767px)` rules in the CSS Modules
const MOBILE_QUERY = '(max-width: 767px)';

const mediaQueryList = window.matchMedia(MOBILE_QUERY);

const subscribe = (onChange: () => void) => {
  mediaQueryList.addEventListener('change', onChange);
  return () => mediaQueryList.removeEventListener('change', onChange);
};

const getSnapshot = () => mediaQueryList.matches;

export function useIsMobile() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
